import { createAuthClient } from "better-auth/client";
import { adminClient, emailOTPClient, magicLinkClient } from "better-auth/client/plugins";

const apiOrigin =
  import.meta.env.VITE_API_BASE_URL ||
  (typeof window === "undefined" ? "http://localhost:8787" : window.location.origin);

export const authClient = createAuthClient({
  baseURL: `${apiOrigin.replace(/\/$/, "")}/api/auth`,
  plugins: [adminClient(), magicLinkClient(), emailOTPClient()],
});
